import React from "react";
import Select, { GroupBase, OptionProps } from "react-select";
import { Controller } from "react-hook-form";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { Col, Row, Label } from "reactstrap";

interface ControlledSelectProps {
  label: string;
  inputName: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
  optionsList?: any;
  isLoading?: boolean;
  isSearchable?: boolean;
  defaultSelectedValue?: any;
  isMulti?: boolean;
  isClear?: boolean;
  value?: any;
  onChange?: (selectedOption: any) => void;
  getOptionLabel?: (option: any) => any | JSX.Element;
  components?: Partial<{
    Option: (props: OptionProps<any, boolean, GroupBase<any>>) => JSX.Element;
  }>;
  onSelectChange?: (selectedOption: any) => void;
  onInputChange?: (inputValue: string, actionMeta: any) => void;
}

const ControlledSelect: React.FC<ControlledSelectProps> = ({
  label,
  inputName,
  optionsList,
  invalid,
  control,
  isLoading,
  isSearchable,
  rules,
  errors,
  defaultSelectedValue,
  isRequired,
  isMulti,
  isDisabled,
  placeholder,
  isClear,
  onChange,
  getOptionLabel,
  components,
  onSelectChange,
  onInputChange
}) => {
  return (
    <div className="mb-1">
      <Row>
        {label && (
          <Col lg="4">
            {label && (
              <Label className={`pt-1 form-label`} htmlFor={inputName}>
                {label} {isRequired && "*"}
              </Label>
            )}
          </Col>
        )}

        <Col lg={label !== "" ? 8 : 12}>
          <Controller
            name={inputName}
            control={control}
            rules={rules}
            render={({ field }) => (
              <Select
                id={inputName}
                classNamePrefix="select"
                options={optionsList}
                isClearable={isClear}
                isLoading={isLoading}
                getOptionLabel={getOptionLabel}
                isSearchable={isSearchable}
                isMulti={isMulti}
                isDisabled={isDisabled}
                defaultValue={defaultSelectedValue}
                components={components}
                placeholder={placeholder}
                {...field}
                required={isRequired}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                  onSelectChange && onSelectChange(selectedOption);
                }}
                onInputChange={onInputChange} // Add this line
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
              />
            )}
          />
          {invalid && (
            <ValidationMsgComponent
              inputName={inputName}
              invalid={invalid}
              errors={errors}
              rules={rules}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};
export default ControlledSelect;